import { LocalStorageKeys } from '~/apps/smartsend/lib/consts/LocalStorageKeys';
import { APP } from '../constants';
import { SmartSendVersions } from '~/apps/smartsend/components/onboarding/hooks/use-smartsend-version';

export function getCookieValues(cookieNames: string[]): { [key: string]: string } {
  if (!document.cookie) return {};
  try {
    return document.cookie.split(';').reduce((acc, cookie) => {
      const key = cookie.substring(0, cookie.indexOf('=')).trim();
      const value = cookie.substring(cookie.indexOf('=') + 1);
      if (!cookieNames.includes(key)) return acc;
      return { ...acc, [key.replace(/^_/, '')]: value.trim() };
    }, {});
  } catch (e) {
    return {};
  }
}

export function parseAbTastyCookie(): { [key: string]: string } {
  const cookie = getCookieValues(['ABTasty']);
  if (!cookie.ABTasty) return {};
  try {
    const vals = new URLSearchParams(cookie.ABTasty);
    const th = vals.get('th');
    if (!th) return {};
    const tests = th.split('_');
    return tests.reduce((acc, test) => {
      const [key, value] = test.split('.');
      return { ...acc, [`test_${key}`]: value };
    }, {});
  } catch (e) {
    return {};
  }
}

export const GenerateBaseAnalyticsPayload = (sections: string[]) => {
  return {
    app: APP,
    section: sections?.map((section) => section.replace(/[^a-zA-Z0-9-]/g, '').replace(/[_\s]+/g, '-')).join(' > '),
    version: localStorage.getItem(LocalStorageKeys.SmartSendPreferredVersion) || SmartSendVersions.Default
  };
};
